import PageProtected from "../../../components/Page/PageProtected";
import Grid from '@mui/material/Grid';
import VaccsSection from "./VaccsSection";
import SectionDashboard from "../../../components/Section/SectionDashboard";
import { useTheme } from "@mui/material";

export default function VaccsWelcome() {

    const theme = useTheme();
   
return (
<>

<PageProtected

        headline="Your Vaccinations - "
        specify="History, Records & Archive"
        
        main={<>

        {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={ <VaccsSection /> }

        />
):(

    <SectionDashboard

        colorContainer="transparent"

        colorSection_1="secondarydark.C100"
        Section_1={ <VaccsSection /> }

    />

    )}
   </>}
/>

</>
)}